import React from 'react';

export const Footer = () => {
    return (
            <footer className="footer">
        <a href="https://www.linkedin.com/in/taman-bachani">Taman Bachani</a> <i class="fas fa-copyright"></i> 2021
    </footer>
    )
}